export const GRIDLOADING_CONFIG = {
  columns: {
    xs: 2,
    sm: 3,
    md: 5
  },
  items: {
    xs: 2,
    sm: 3,
    md: 5
  }
}
export const CONFIG_GRID = {
  xs: {
    columns: 2,
    defaultColumnWidth: 170,
    rowHeight: 170,
    gutter: 6
  },
  sm: {
    columns: 3
  },
  default: {
    columns: 5,
    defaultColumnWidth: 250,
    rowHeight: 300,
    gutter: 8
  }
}
